<div class="login">

  <!-- Right panel: status -->
  <div class="login__panel login__panel--right">
    <div class="login-form">

      <ng-container [ngSwitch]="status">

        <div *ngSwitchCase="'confirming'" class="login-form__field">
          <h2 class="login-form__label">Confirming your email…</h2>
          <p class="login-form__hint">This will just take a moment.</p>
        </div>

        <div *ngSwitchCase="'success'" class="login-form__field">
          <h2 class="login-form__label">Email confirmed</h2>
          <p class="login-form__hint">{{ message }}</p>
          <div class="login-form__actions">
            <button class="btn btn--primary" type="button" (click)="goToLogin()">Go to sign in</button>
          </div>
        </div>

        <div *ngSwitchCase="'error'" class="login-form__field">
          <h2 class="login-form__label">Confirmation failed</h2>
          <p class="login-form__error">{{ message }}</p>
          <div class="login-form__actions">
            <a routerLink="/login" class="btn btn--primary">Back to sign in</a>
            <p class="login-form__footer">
              Need a new link? <a routerLink="/signup" class="link">Sign up again</a>
            </p>
          </div>
        </div>

      </ng-container>

    </div>
  </div>

  <!-- Left panel: branding mosaic -->
  <div class="login__panel login__panel--left">
    <app-auth-panel></app-auth-panel>
  </div>

</div>
